import {
	type IkeActionCollectionLoadingSummary,
	type IkeActionCollectionStatusSummary,
	type IkeActionCollectionTotalStatusSummary,
} from '@ikegps/core-api';
import { type IkeClientService, Services } from '.';

export class DashboardService implements IkeClientService {
	__priority: number = 50;

	async getPoleStatusTotals() {
		const rest = Services.Department.rest;
		return (await rest.action<IkeActionCollectionTotalStatusSummary>('collection.total.status.summary', '')).results;
	}

	async getPoleStatusSummary() {
		const rest = Services.Department.rest;
		return (await rest.action<IkeActionCollectionStatusSummary>('collection.status.summary', '')).results;
	}

	async getPoleLoadingSummary() {
		const rest = Services.Department.rest;
		return (await rest.action<IkeActionCollectionLoadingSummary>('collection.loading.summary', '')).results;
	}
}
